// foundations/radii.js
const radii = {
  none: "0",
  xs: "2px",
  sm: "4px", // Small radius
  md: "8px", // Medium radius
  lg: "10px", // Large radius
  xl: "12px", // Extra large radius
  "2xl": "20px",
  full: "9999px", // Fully rounded (for pills, circles, etc.)
};

export default radii;
